export default {
  'business-case-for-abortion-access': {
    tag: 'abortion-access'
  },
  'ambition-diaries': {
    tag: 'ambition-diaries'
  }
  // 'ambition-diaries': {
  //   tag: 'ambition-diaries'
  // }
};
